// extracted by mini-css-extract-plugin
module.exports = {"textMarquee":"TextMarquee_textMarquee__R2_TT","slider":"TextMarquee_slider__J8Qca"};